<script lang="ts">
	interface Props {
		current_progress: number;
		current_max: number;
	}

	let { current_progress, current_max }: Props = $props();
	let progressPct = $derived(
		current_max > 0 ? Math.min(Math.max((current_progress / current_max) * 100, 0), 100) : 0
	);
</script>

<div class="h-1 w-full overflow-hidden rounded-full bg-primary-500/40 md:h-2 dark:bg-primary-900">
	<div
		class="h-full rounded-full bg-primary-500 transition-all duration-300"
		style="width: {progressPct}%"
	></div>
</div>
<div class="grid grid-cols-2 pt-1 font-manrope text-sm font-extrabold">
	<div class="text-left">
		{Math.trunc(current_progress / 60)
			.toString()
			.padStart(2, '0')}:{Math.trunc(current_progress % 60)
			.toString()
			.padStart(2, '0')}
	</div>
	<div class="text-right">
		{Math.trunc(current_max / 60)
			.toString()
			.padStart(2, '0')}:{Math.trunc(current_max % 60)
			.toString()
			.padStart(2, '0')}
	</div>
</div>
